import React, { useEffect, useState, useContext } from 'react';
import AuthContext from '../../context/AuthProvider';
import './MySessions.css';

const MySessions = () => {
  const { auth } = useContext(AuthContext);
  // If using localStorage:
  const token = auth?.accessToken || localStorage.getItem('authToken');

  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchSessions = async () => {
      setLoading(true);
      setError('');
      try {
        // Assuming auth.user contains the userId or token
        const response = await fetch(`${process.env.REACT_APP_API_BASE}/users/booked-sessions`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        });
        if (!response.ok) throw new Error('Failed to fetch sessions');
        const data = await response.json();
        // If data is not an array, wrap it
        const sessionsArray = Array.isArray(data) ? data : [data];
        setSessions(sessionsArray);
      } catch (err) {
        setError('Could not load your sessions. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    if (token) {
      fetchSessions();
    } else {
      setLoading(false);
      setSessions([]);
    }
  }, [auth]);

  return (
    <div className="my-sessions-container">
      <h1>My Booked Sessions</h1>
      {loading && <p>Loading...</p>}
      {error && <p className="error-message">{error}</p>}
      {!loading && !error && sessions.length === 0 && <p>No sessions booked yet.</p>}
      {!loading && !error && sessions.length > 0 && (
        <table className="sessions-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Time</th>
              <th>Type</th>
              <th>Message</th>
            </tr>
          </thead>
          <tbody>
            {sessions.map((session, idx) => (
              <tr key={idx}>
                <td>{session.Date}</td>
                <td>{session.Time}</td>
                <td>{session.SessionType || '-'}</td>
                <td>{session.Message}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default MySessions;
